<template lang="pug">
  
.row.gy-5.g-xl-8
  .col-12
    .card.mb-5.mb-xxl-10
      .card-header
        .card-title
          h3 Uso da API
      .card-body.py-10
        .row.mb-10(v-if="hasApi")
          .col-md-6.pb-10.pb-lg-0
            h2 Token de acesso
            p.fs-6.fw-bold.text-gray-600.py-2
              | Utilize esse token no Authorization do Header das suas requisições
              input#codeHash(type='hidden' :value='hash')
            p.text-dark-50.m-0.pt-5.font-weight-normal.mb-5
              | {{ hash }}
            button.btn.btn-light.btn-active-light-primary(@click="copyCodeHash") Copiar token
          .col-md-6
            h2 Documentação
            p.fs-6.fw-bold.text-gray-600.py-2
              | Tenha acesso a nossa documentação do Swagger.
              br
              | api.consensu.io
            a.btn.btn-primary.btn-active-light-primary(href='https://api.consensu.io/documentation' target="_blank") Clique aqui
        .row.mb-10(v-else)
          p.text-muted.fw-bold.fs-6 Faça upgrade do seu plano para ter acesso a API!

</template>

<script>
import { defineComponent, onMounted, computed } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { useStore } from "vuex";
import { useAcl } from "vue-simple-acl/dist/vue-simple-acl.vue2";
import JwtService from "@/core/services/JwtService";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default defineComponent({
  name: "api",

  components: {},

  setup() {
    const store = useStore();
    const acl = useAcl();

    const idUser = store.getters.currentUser._id;

    const hasApi = computed(() => {
      return acl.can("has-api");
    });

    onMounted(() => {
      setCurrentPageTitle("API");
    });

    return { idUser, hasApi };
  },

  data() {
    return {};
  },

  computed: {
    hash() {
      return `Bearer ${JwtService.generateToken({
        user: this.idUser,
      })}`;
    },
  },

  methods: {
    copyCodeHash() {
      const codeJS = document.querySelector("#codeHash");

      codeJS.setAttribute("type", "text"); // 不是 hidden 才能複製
      codeJS.select();

      try {
        var successful = document.execCommand("copy");
        var msg = successful
          ? "Token copiado com sucesso!"
          : "Token copiado com sucesso!";
        Swal.fire({
          text: msg,
          position: "top-end",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
          heightAuto: false,
        });
        // alert('Testing code was copied ' + msg);
      } catch (err) {
        // alert('Oops, unable to copy');
      }

      /* unselect the range */
      codeJS.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
  },
});
</script>
